<template>
  <div class="table-cell">
    <el-table :data="tableData" >
      <el-table-column  prop="ranking" label="排名" width="40"></el-table-column>
      <el-table-column  prop="division" label="区域名称" width="80"></el-table-column>
      <el-table-column  prop="buildingName" label="建筑名称" width="80"></el-table-column>
      <el-table-column  prop="merchantName" label="单位/商户名称" width="80"></el-table-column>
      <el-table-column  prop="buildingArea" label="建筑总面积（m³）"></el-table-column>
      <el-table-column  prop="airConditionerArea" label="空调总面积（m³）"></el-table-column>
      <el-table-column  prop="peopleNumber" label="使用人数（人）" width="80"></el-table-column>
      <el-table-column  prop="totalEnergy" :label="'总能耗'+tableHeadName" sortable></el-table-column>
      <el-table-column  prop="perCapitaEnergy" :label="'人均能耗'+tableHeadName" width="140" sortable></el-table-column>
      <el-table-column  prop="unitAreaEnergy" :label="'单位面积能耗'+tableHeadName" width="160" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {getSession} from "../../assets/js/tools/instruments";

  export default {
name: "printECRanking",
  data(){
    return{
      tableData: [],
      tableHeadName: '(tce)'
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    getTableData(){
      let temp = getSession('ECRankingData').split(',');
      let str = '';
      for( let i in temp ){
        if( i >7 ){
          if( i < temp.length-1) {
            str = str + temp[i] + ',';
          } else {
            str = str + temp[i];
          }
        }
      }
      let arr = [temp[0], temp[1],temp[2], temp[3],temp[4], temp[5],temp[6], temp[7],str];
      this.$get('ecranking/getenergyrankingdate',arr).then((response)=>{
        this.tableData = response.getEnergyRankingData;
        for( let i in this.tableData) {
          this.tableData[i].merchantName = "-";
          this.tableData[i].totalEnergy *= 1;
          if ( this.tableData[i].perCapitaEnergy == "-"){
            this.tableData[i].perCapitaEnergy = 0;
          } else {
            this.tableData[i].perCapitaEnergy *= 1;
          }
          this.tableData[i].unitAreaEnergy *= 1;
        }
        if( temp[1] ==="0"){
            this.tableHeadName = '(tce)'
          } else if ( temp[1] ==="1" ){
            this.tableHeadName = '(kW·h)'
          } else if ( temp[1] ==="2" ){
            this.tableHeadName = '(m³)'
          } else {
            this.tableHeadName = '(t)'
          }
        setTimeout(function (){
          this.print()
        },500)
     })
    },
    print(){
      window.print()
    }
  }
}
</script>

<style scoped lang="scss">
 .table-cell{
   width: 1060px;
   margin: 40px auto;
 }
</style>